import docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver'

const exportWord = (
  data,
  docTitle = 'mugedaDoc',
) => {
  return new Promise((resolve, reject) => {  // 添加Promise包装
    JSZipUtils.getBinaryContent('/rm/files/aiExport.docx', function(
      error,
      content
    ) {
      if (error) {
        console.error('模板文件加载失败:', error);
        reject(error);
        return;
      }

      try {
        const zip = new PizZip(content);
        const doc = new docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true
        });

        doc.render(data);
        
        const out = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        
        saveAs(out, `${docTitle}.doc`);
        resolve();
      } catch (error) {
        console.error('文档生成过程出错:', error);
        reject(error);
      }
    });
  });
}

export default exportWord;
